export function getMenuByUrl() {
    var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var menu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var urls = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;


    menu.forEach(function (item) {

        item.level = level;

        if (root && item.path) {
            item.url = root + item.path;
        } else if (root) {
            item.url = root;
        }

        if (item.url) {
            urls[item.url] = item;
        }

        if (item.children) {
            urls = getMenuByUrl(root, item.children, urls, level++);
        }
    });

    return urls;
}